// extracted by mini-css-extract-plugin
var _1 = "footer--ur9YHUQ";
export { _1 as "footer" }
